export class ComposeEmailTicketConstants {
    public static ERROR_MESSAGE = {
        'must_be_email': 'Please be sure to use a valid email format'
    };
    public static EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/compose-email.constants.ts